import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react"
import { ArrowLeft, HouseSimple } from "@phosphor-icons/react"
import * as React from "react"
import { useContext } from "react"
import { useMediaQuery } from "react-responsive"
import { Link, useNavigate } from "react-router-dom"
import AuthContext from "../AuthContext"
import Notfound from "../Images/404.svg"
import ErrorPageImg from "../Images/ep2.svg"
import { IS_MOBILE_MEDIA_QUERY, ROUTES } from "../utils/constants"

export default function NotFoundPage() {
  const isMobile = useMediaQuery(IS_MOBILE_MEDIA_QUERY)
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" })
  const navigate = useNavigate()

  const { currentUser } = useContext(AuthContext)

  return (
    <Box
      color="black"
      backgroundColor="white"
      layerStyle="bluebg"
      minHeight="100vh"
      m="0"
    >
      <Flex justifyContent="center" alignItems="center" w="100%" h="100vh">
        <Stack
          rounded="xl"
          py="15"
          px="12"
          bgColor="whiteAlpha.50"
          shadow="sm"
          direction={isPortrait ? "column" : "row"}
          spacing="2"
        >
          <Flex justifyContent="center">
            <VStack
              justifyContent="center"
              alignItems="flex-start"
              p="2rem"
              pos="relative"
            >
              <Box
                opacity={0.3}
                backgroundImage={Notfound}
                w={isMobile ? "14rem" : "20rem"}
                h="8rem"
                backgroundRepeat="no-repeat"
                backgroundSize="contain"
              />
              <Image
                pt="4"
                src={ErrorPageImg}
                w="100%"
                h="auto"
                alt="page not found"
                objectFit="contain"
              />
            </VStack>
          </Flex>

          <VStack
            py="2rem"
            px={isMobile ? "0" : "4rem"}
            alignItems="center"
            maxWidth="25rem"
          >
            <Heading textAlign="center" as="h1" size="xl">
              Page not found
            </Heading>
            <Box>
              <Text fontSize="xl">
                Sorry, the page you requested doesn't exist.
              </Text>
              <Text fontSize="xl" mt="2">
                {" "}
                But nothing to worry about: we have lots of other pages for you
                to see.
              </Text>
            </Box>
            <Box>
              <ButtonGroup mt={["5", "8", "10"]}>
                <Button
                  leftIcon={<ArrowLeft />}
                  bgColor="yellow"
                  color="normblack"
                  onClick={() => navigate(-1)}
                >
                  Go back
                </Button>
                <Link to={currentUser ? ROUTES.MEETINGS : "/"}>
                  <Button
                    leftIcon={<HouseSimple />}
                    bgColor="yellow"
                    color="normblack"
                  >
                    Return home
                  </Button>
                </Link>
              </ButtonGroup>
            </Box>
          </VStack>
        </Stack>
      </Flex>
    </Box>
  )
}
